import { Accordion, AccordionDetails, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// todo uikit: remove these after cleaning accordion filter component

export const Wrapper = styled(Accordion)`
  &.open {
    border: 1px solid ${(p) => p.theme.palette.primary[500]};
    border-radius: 0;
  }

  &.open.pinningMode {
    border-radius: ${(p) => p.theme.spacing(1)};
  }

  &.isMini:hover > div > div > div > div > div > svg {
    color: ${(p) => p.theme.palette.primary[500]};
  }
`;

export const ContentSummary = styled(Box)`
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;

  &.mini {
    width: auto;
    height: 21px;
  }

  &.closed {
    gap: ${(p) => p.theme.spacing(1)};
  }
`;

export const Details = styled(AccordionDetails)`
  &.pinningMode {
    background-color: ${(p) => p.theme.palette.common.white};
    border-radius: 0 0 ${(p) => p.theme.spacing(1)} ${(p) => p.theme.spacing(1)};
    padding: ${(p) => p.theme.spacing(0.5, 2)};
  }

  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(1)};
`;
